import { UPDATE_SEARCHTDATA_KIEMKHO } from "../../actions/KiemKho/actionTypes";

const initialState = {
  maTaiSan: "",
  kho: 0,
  trangThai: -1,
  pageIndex: 1,
  pageSize: 25,
  ListDaKiemKho: [],
};

const updateDataSearch = (state, action) => ({
  ...action.payload,

  //matentaisan: action.payload.matentaisan,
  //searchText: action.payload,
});

export const dataSearchKiemKho = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SEARCHTDATA_KIEMKHO:
      return updateDataSearch(state, action);
    default:
      return state;
  }
};

export default dataSearchKiemKho;
